import { SubCategoryRepository, CreateSubCategoryInput } from '../../domain/repositories/sub-category.repository';
import { SubCategoryEntity } from '../../domain/entities/sub-category.entity';

export class CreateSubCategoryUseCase {
  constructor(private readonly subCategoryRepository: SubCategoryRepository) {}

  async execute(input: CreateSubCategoryInput): Promise<SubCategoryEntity> {
    return this.subCategoryRepository.createSubCategory(input);
  }
}
